module.exports = __webpack_public_path__ + "app/principal/company-relations-27OJL3iW.html";